import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";

export default function HistoryChangeDetails({
  changeCount = 0,
  defaultExpanded = false,
  children,
}) {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  return (
    <Box className="tn-history-details-container">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: expanded ? 1 : 0 }}
      >
        <Typography className="tn-history-change-count">
          {changeCount} change{changeCount === 1 ? "" : "s"}
        </Typography>
        <Button
          size="small"
          onClick={() => setExpanded((prev) => !prev)}
          className="tn-history-view-details-btn"
          endIcon={
            <GoogleMaterialIcon
              name={expanded ? "expand_less" : "expand_more"}
              size={18}
            />
          }
        >
          {expanded ? "Hide details" : "View details"}
        </Button>
      </Stack>
      {expanded && <Box className="tn-history-details-content">{children}</Box>}
    </Box>
  );
}
